import React from 'react';
import PropTypes from 'prop-types';


const CategoryTag = function CategoryTagComponent({ tagline, imageUrl }) {
  return (
    <div className="category-tag__wrapper">
      <p className="category-tag__text">
        {tagline}
      </p>
      <img className="category-tag__image" src={imageUrl} alt="Co-branding Partner Logo" />
    </div>
  );
};

CategoryTag.propTypes = {
  tagline: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default CategoryTag;
